import { deleteDatabase } from "../helper/dbHelper.js";
import db from '../helper/dbHelper.js';
import { getBlockedAddress, getGeneralSettings } from '../helper/apiHelper.js'

export const clearComposeBox = () => {
    localStorage.removeItem('recipient');
    localStorage.removeItem('cc');
    localStorage.removeItem('bcc');
    localStorage.removeItem('subject');
    localStorage.removeItem('message');
}

export const logout = async () => {
    await clearStorage();
    window.open('/', '_self');
}

export const clearStorage = async () => {
    clearComposeBox()
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('timeZone');
    await deleteDatabase();
}

export const convertToLocal = (UTCtime) => {
    try {
        if (!UTCtime) return "";
        const hasZ = UTCtime.toLowerCase().endsWith('z');
        const dateString = hasZ ? UTCtime : UTCtime + 'z';
        const utcDate = new Date(dateString);
        let timeZone = localStorage.getItem('timeZone') ?? 'system';
        const timeZoneToUse = timeZone === 'system' ? Intl.DateTimeFormat().resolvedOptions().timeZone : timeZone;

        const localTime = new Intl.DateTimeFormat('en-GB', {
            timeZone: timeZoneToUse,
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).format(utcDate);

        return localTime;

    } catch (error) {
        console.error('Error converting date:', error);
        return "";
    }
};

export const fomatedEmail = async (data, pageType) => {
    let blockedAddress = [];
    let isGrouped = false;
    if (pageType !== 'sent') {
        const response = await getBlockedAddress();
        if (response) {
            blockedAddress = response.address.split(',')
        }
    }
    const getGeneral = await getGeneralSettings();
    if (getGeneral) {
        isGrouped = getGeneral.is_group;
    }
    const value = await Promise.all(data.map(async (email) => {
        const data = JSON.parse(email.parts[0].data);
        const encrypted_data = data.encrypted_data;
        const emailDetails = JSON.parse(data.email_details[1]);
        const sender = emailDetails.sender;
        const subject = emailDetails.subject;
        const isRead = email.parts[0].is_read === 1;
        const isFav = email.parts[0].fav == 1 ? true : false;
        const isSent = email.parts[0].is_sent == 1 ? true : false;
        return {
            created_at: email.parts[0].internal_date,
            receivedDate: email.parts[0].internal_date,
            id: email.parts[0].message_id,
            encryptedData: encrypted_data,
            decryptedData: await getDecryptedValue(pageType, email.parts[0].message_id),
            isStarred: isFav,
            sender: sender,
            senderName: sender,
            subject: subject,
            isRead: isRead,
            header: data.email_details[1],
            emailDetails: data.email_details[1],
            isSent: isSent
        };
    }));
    const filteredValue = value.filter(item => !blockedAddress.includes(item.sender));
    const finaldata = isGrouped ? await groupMessages(filteredValue, pageType) : filteredValue;
    return finaldata;
}

const groupMessages = async (messageList, pageType) => {
    const grouped = messageList.reduce((acc, message) => {
        const key = pageType !== 'sent'
            ? `${message.sender}___${message.subject}`
            : (() => {
                const data = JSON.parse(message.emailDetails);
                return `${[data.to, data.cc, data.bcc].filter(Boolean).join(", ").split(',')[0]}___${message.subject}`;
            })();

        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(message);

        return acc;
    }, {});


    const filteredGrouped = Object.fromEntries(
        Object.entries(grouped).filter(([key, messages]) => messages.length > 1)
    );

    const filteredMessageIds = Object.values(filteredGrouped).flat().map(message => message.id)
    const filteredMessageList = messageList.filter(message => !filteredMessageIds.includes(message.id));
    Object.entries(filteredGrouped).forEach(([key, value]) => {
        filteredMessageList.push({ groupKey: key, created_at: value[0].created_at, data: value });
    });
    filteredMessageList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    return filteredMessageList;
};

const getDecryptedValue = async (table, id) => {
    const existingMail = await db[table].where('mailId').equals(id).toArray();

    if (existingMail.length > 0) {
        return existingMail[0].decryptedMail;
    } else {
        return null;
    }
};

export const getBrowserDetails = async () => {
    let ip = null;
    await fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => (ip = data.ip))
        .catch(error => console.error('Error fetching IP address:', error));
    const details = {
        appVersion: navigator.appVersion,
        platform: navigator.platform,
        ip: ip
    };
    return JSON.stringify(details);
};